import React, {Component} from 'react'
import {Modal, Radio, Result, Select} from 'antd';
import {UserAction} from '../../actions/UserAction'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {config, gaPageView} from "../../constants";
import "./paytest.css"
import {Input} from 'reactstrap';
import axios from 'axios';
import customerService from '../../services/customer.service';
import authHeader from '../../services/auth-header';
import i18n from "i18next";

class TXPaytest extends Component {

    constructor(props) {

        super(props);

        this.state = {
            operation: "",
            pendingRequest: false,
            response: null
        }

    }

    componentDidMount() {
        gaPageView()

        customerService.getCustomers().then(response => {
            const customersData = response.data;
            this.setState(
                {
                    customers: customersData,
                    customersselect: customersData.map(customer => {
                        return (
                            <Select.Option key={customer.customerDataStr} value={customer.customerDataStr}>{customer.fullName}</Select.Option>
                        )
                    }),
                    recipientcustomersselect: customersData.map(customer => {
                        return (
                            <Select.Option key={customer.customerNo} value={customer.customerNo}>{customer.fullName}</Select.Option>
                        )
                    })
                })
        })

    }

    handleChange = (selectType, val) => {
        this.setState(prevState => (
            {
                ...prevState,
                [selectType]: val
            })
        )
    }

    handleRadioChange = (e) => {
        this.setState(prevState => (
            {
                transferType: e.target.value
            })
        )
    }

    isNumeric(str) {
        if (typeof str != "string") return false // we only process strings!
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }

    handleInputChange = (e) => {
        const {name, value} = e.target

        if (name == "amount") {
            let result = ""
            for (let i = 0; i < value.length; i++) {
                const inp = value[i]
                if (this.isNumeric(inp)) {
                    result += inp
                }
            }
            this.setState({[name]: result})
            return
        }

        this.setState({[name]: value})
    }
    formattedMoney = (money) => {
        if (!money) return money;
        money = money.replaceAll(".", "")

        let result = []
        let counter = 0;
        for (let i = money.length - 1; i >= 0; i--) {
            counter++
            if (counter % 4 == 0) {
                result.push(".")
                counter = 1
            }
            result.push(money[i])
        }
        (result).reverse()

        return (result.join(""))
    }

    pay = () => {

        let request = {
            "rules": [
                "K19"
            ],
            "txType": this.state.operation,
            "txData": {
                "operationSubType": this.state.transferType,
                "recipientCustomerNo": this.state.customer2,
                "transferAmount": this.state.amount,
                "transferCurrency": this.state.currency,
                "cardNumber": this.state.cardnumber,
                "cvcNumber": this.state.cvcnumber,
                "ibanNumber": this.state.ibannumber,
                "month": this.state.month,
                "year": this.state.year,
                "address": this.state.address
            },
            "customer": JSON.parse(this.state.customer1)
        }


        axios.post(config.API_URL + "transaction/push", request, {headers: authHeader()})
            .then(response => {

                let stop = response.data.stop;

                Modal.info({
                    centered: true,
                    content:
                        <Result
                            status={!stop ? "success" : "error"}
                            title={!stop ? i18n.t("tx_paytest_success_title") : i18n.t("tx_paytest_fail_title")}
                            subTitle={!stop ? i18n.t("tx_paytest_success_subTitle") : i18n.t("tx_paytest_fail_subTitle")}
                        />
                    ,
                    onOk() {
                    }
                })

                this.setState({response: response.data})
            });

    }

    render() {

        return (
            <>
                <div className='txpaytest-page-container'>

                    <div className='settings-container'>

                        <div className='paytest-settings-field'>
                            <div className='paytest-field-text'>
                                <label className='paytest-label'>{i18n.t("txpaytest_operation")}</label>
                                <small className='paytest-small'>{i18n.t("txpaytest_select_operation")}</small>
                            </div>
                            <Select
                                className='paytest-select pi-full'
                                showSearch
                                optionFilterProp="children"
                                onChange={val => this.handleChange("operation", val)}
                            >
                                {["payment", "transfer", "crypto_currency"].map(opt => {
                                    return (
                                        <Select.Option key={opt} value={opt}>{i18n.t("txpaytest_" + opt)}</Select.Option>
                                    )
                                })}
                            </Select>
                        </div>

                        <div className='paytest-settings-field'>
                            <div className='paytest-field-text'>
                                <label className='paytest-label'>{i18n.t("txpaytest_customer")}</label>
                                <small className='paytest-small'>{i18n.t("txpaytest_select_customer")}</small>
                            </div>
                            <Select
                                className='paytest-select pi-full'
                                showSearch
                                optionFilterProp="children"
                                onChange={val => this.handleChange("customer1", val)}
                            >
                                {this.state.customersselect}
                            </Select>

                        </div>

                        {this.state.operation == "transfer" &&
                            <div className='paytest-settings-field'>
                                <div className='paytest-field-text'>
                                    <label className='paytest-label'>{i18n.t("txpaytest_transfer_type")}</label>
                                    <small className='paytest-small'>{i18n.t("txpaytest_select_transfer_type")}</small>
                                </div>

                                <Radio.Group onChange={e => this.handleRadioChange(e)} defaultValue={this.state.transferType}>
                                    <Radio.Button value="internal">{i18n.t("txpaytest_internal")}</Radio.Button>
                                    <Radio.Button value="external">{i18n.t("txpaytest_external")}</Radio.Button>
                                </Radio.Group>

                            </div>
                        }

                        {this.state.operation == "crypto_currency" &&

                            <div className='paytest-settings-field'>
                                <div className='paytest-field-text'>
                                    <label className='paytest-label'>{i18n.t("txpaytest_transfer_type")}</label>
                                    <small className='paytest-small'>{i18n.t("txpaytest_select_transfer_type")}</small>
                                </div>

                                <Radio.Group onChange={e => this.handleRadioChange(e)} defaultValue={this.state.transferType}>
                                    <Radio.Button value="deposit">{i18n.t("txpaytest_deposit")}</Radio.Button>
                                    <Radio.Button value="withdraw">{i18n.t("txpaytest_withdraw")}</Radio.Button>
                                </Radio.Group>

                            </div>
                        }

                    </div>

                    {this.state.operation == "payment" &&
                        <div className='paytest-container'>

                            <div className='paytest-left'>
                                <div className='paytest-field pf-col'>
                                    <div className='paytest-field-text'>
                                        <label className='paytest-label'>{i18n.t("txpaytest_card_number")}</label>
                                        <small className='paytest-small'>{i18n.t("txpaytest_enter_card")}</small>
                                    </div>
                                    <Input type='text' className='paytest-input pi-full' onChange={this.handleInputChange} name="cardnumber"/>
                                </div>
                                <div className='paytest-field pf-row'>
                                    <div className='paytest-field-text'>
                                        <label className='paytest-label'>{i18n.t("txpaytest_cvc_number")}</label>
                                        <small className='paytest-small'>{i18n.t("txpaytest_enter_cvc")}</small>
                                    </div>
                                    <Input type='text' className='paytest-input pi-half' onChange={this.handleInputChange} name="cvcnumber"/>
                                </div>
                                <div className='paytest-field pf-row'>
                                    <div className='paytest-field-text'>
                                        <label className='paytest-label'>{i18n.t("txpaytest_expiry_date")}</label>
                                        <small className='paytest-small'>{i18n.t("txpaytest_enter_expiry_date")}</small>
                                    </div>
                                    <input type='text' className='paytest-input pi-qrt' placeholder='MM' onChange={this.handleInputChange} name="month"></input>
                                    <input type='text' className='paytest-input pi-qrt' placeholder='YY' onChange={this.handleInputChange} name="year"></input>
                                </div>
                            </div>

                            <div className='paytest-right'>

                                <div className='paytest-field pf-col'>
                                    <div className='paytest-field-text'>
                                        <label className='paytest-label'>{i18n.t("txpaytest_amount_and_currency")}</label>
                                        <small className='paytest-small'>{i18n.t("txpaytest_enter_amount_and_currency")}</small>
                                    </div>
                                    <div className='pi-half-container'>
                                        <Select
                                            className='paytest-select pi-25'
                                            showSearch
                                            defaultValue={"TRY"}
                                            optionFilterProp="children"
                                            onChange={val => this.handleChange("currency", val)}
                                        >
                                            {["USD", "EUR", "TRY"].map(currency => {
                                                return (
                                                    <Select.Option key={currency} value={currency}>{currency}</Select.Option>
                                                )
                                            })}
                                        </Select>
                                        <Input type='text' value={this.formattedMoney(this.state.amount)} className='paytest-input pi-75'
                                               onChange={this.handleInputChange} name="amount"/>
                                    </div>

                                </div>
                                {
                                    this.state.currency && this.state.amount && this.state.customer &&
                                    <p>You are going to pay {this.state.currency} {this.formattedMoney(this.state.amount)} to the customer named
                                        "{this.state.customer}"</p>
                                    /* todo */
                                }

                                <button onClick={this.pay} className='paytest-pay-btn'>{i18n.t("txpaytest_pay")}</button>

                            </div>

                        </div>
                    }

                    {this.state.operation == "transfer" && (this.state.transferType == "internal" || this.state.transferType == "external") &&
                        <div className='paytest-container paytest-transfer'>

                            <div className='paytest-right'>
                                {this.state.transferType == "external" &&
                                    <div className='paytest-field pf-col'>
                                        <div className='paytest-field-text'>
                                            <label className='paytest-label'>{i18n.t("txpaytest_iban")}</label>
                                            <small className='paytest-small'>{i18n.t("txpaytest_enter_iban")}</small>
                                        </div>
                                        <Input type='text' className='paytest-input pi-full' onChange={this.handleInputChange} name="ibannumber"/>
                                    </div>}

                                {this.state.transferType == "internal" &&
                                    <div className='paytest-field pf-col'>
                                        <div className='paytest-field-text'>
                                            <label className='paytest-label'>{i18n.t("txpaytest_recipient")}</label>
                                            <small className='paytest-small'>{i18n.t("txpaytest_select_recipient")}</small>
                                        </div>
                                        <Select
                                            className='paytest-select pi-full'
                                            showSearch
                                            optionFilterProp="children"
                                            onChange={val => this.handleChange("customer2", val)}
                                        >
                                            {this.state.recipientcustomersselect}
                                        </Select>
                                    </div>}

                                <div className='paytest-field pf-col'>
                                    <div className='paytest-field-text'>
                                        <label className='paytest-label'>{i18n.t("txpaytest_amount_and_currency")}</label>
                                        <small className='paytest-small'>{i18n.t("txpaytest_enter_amount_and_currency")}</small>
                                    </div>
                                    <div className='pi-half-container'>
                                        <Select
                                            className='paytest-select pi-25'
                                            showSearch
                                            defaultValue={"TRY"}
                                            optionFilterProp="children"
                                            onChange={val => this.handleChange("currency", val)}
                                        >
                                            {["USD", "EUR", "TRY"].map(currency => {
                                                return (
                                                    <Select.Option key={currency} value={currency}>{currency}</Select.Option>
                                                )
                                            })}
                                        </Select>
                                        <Input type='text' className='paytest-input pi-75' onChange={this.handleInputChange}
                                               value={this.formattedMoney(this.state.amount)} name="amount"/>
                                    </div>
                                </div>

                                <button onClick={this.pay} className='paytest-pay-btn'>{i18n.t("txpaytest_pay")}</button>

                            </div>

                        </div>
                    }

                    {
                        this.state.operation == "crypto_currency" && (this.state.transferType == "deposit" || this.state.transferType == "withdraw") &&

                        <div className='paytest-container paytest-transfer'>

                            <div className='paytest-right'>
                                {
                                    this.state.transferType == "deposit" &&
                                    <div className='paytest-field pf-col'>
                                        <div className='paytest-field-text'>
                                            <label className='paytest-label'>{i18n.t("txpaytest_address")}</label>
                                            <small className='paytest-small'>{i18n.t("txpaytest_enter_deposit_address")}</small>
                                        </div>
                                        <Input type='text' className='paytest-input pi-full' onChange={this.handleInputChange} name="address"/>
                                    </div>
                                }

                                {
                                    this.state.transferType == "withdraw" &&
                                    <div className='paytest-field pf-col'>
                                        <div className='paytest-field-text'>
                                            <label className='paytest-label'>{i18n.t("txpaytest_address")}</label>
                                            <small className='paytest-small'>{i18n.t("txpaytest_enter_withdraw_address")}</small>
                                        </div>
                                        <Input type='text' className='paytest-input pi-full' onChange={this.handleInputChange} name="withdrawAddress"/>
                                    </div>
                                }

                                <div className='paytest-field pf-col'>
                                    <div className='paytest-field-text'>
                                        <label className='paytest-label'>{i18n.t("txpaytest_amount_and_currency")}</label>
                                        <small className='paytest-small'>{i18n.t("txpaytest_enter_amount_and_currency")}</small>
                                    </div>
                                    <div className='pi-half-container'>
                                        <Select
                                            className='paytest-select pi-25'
                                            showSearch
                                            defaultValue={"BTC"}
                                            optionFilterProp="children"
                                            onChange={val => this.handleChange("currency", val)}
                                        >
                                            {["BTC", "ETH", "USDT", "BNB"].map(currency => {
                                                return (
                                                    <Select.Option key={currency} value={currency}>{currency}</Select.Option>
                                                )
                                            })}
                                        </Select>
                                        <Input type='text' className='paytest-input pi-75' value={this.formattedMoney(this.state.amount)}
                                               onChange={this.handleInputChange} name="amount"/>
                                    </div>
                                </div>

                                <button onClick={this.pay} className='paytest-pay-btn'>{i18n.t("txpaytest_pay")}</button>

                            </div>

                        </div>

                    }

                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(TXPaytest);